import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchMembers, setMemberType, setSelectedPayer } from '../actions';
import { MemberTypes, MemberStatuses } from '../constants';
import CsvFileChooser from './CsvFileChooser';
import PayerSelect from '../components/PayerSelect';

export class TestMemberChooserUnconnected extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(name, value) {
    // Form elements invoke this change handler with the element name and value,
    // which we store in the state.
    if (name === "payerId") {
      this.props.setSelectedPayer(value);
    }

    this.setState({ [name]: value });
  }

  handleSubmit(event) {
    const { fetchMembers: fetchMembersAction } = this.props;

    event.preventDefault();
    fetchMembersAction(this.state);
  }

  renderMemberTypeSelect() {
    const { memberType } = this.props;
    const onTypeChanged = e => this.props.setMemberType(e.currentTarget.value);

    return (
      <tr>
        <th><label htmlFor="file">Member Type</label></th>
        <td>
          <input
            className="radio-type-csv"
            type="radio"
            name="memberType"
            checked={memberType === MemberTypes.CSV_FILE}
            onChange={onTypeChanged}
            value={MemberTypes.CSV_FILE}
          />
          &nbsp; CSV File &nbsp;

          <input
            className="radio-type-existing"
            type="radio"
            name="memberType"
            checked={memberType === MemberTypes.EXISTING_MEMBERS}
            onChange={onTypeChanged}
            value={MemberTypes.EXISTING_MEMBERS}
          />
          &nbsp; Existing Members
        </td>
      </tr>
    );
  }

  renderFormFields() {
    const { memberType, payers } = this.props;

    switch (memberType) {
      case MemberTypes.CSV_FILE:
        return <CsvFileChooser />;
      case MemberTypes.EXISTING_MEMBERS:
        const onGroupIdChange = e => this.handleChange('groupId', e.target.value);
        const onLimitChange   = e => this.handleChange('limit', e.target.value);
        return ([
          <PayerSelect
            key="payer"
            payers={payers}
            allowBlank
            onChange={this.handleChange}
            wrapTableRow
          />,
          <tr className="member-form-field" key="group_id">
            <th><label htmlFor="group_id">Group ID</label></th>
            <td><input className="group-id-input" type="text" onChange={onGroupIdChange} /></td>
          </tr>,
          <tr className="member-form-field" key="limit">
            <th><label htmlFor="limit"># Members</label></th>
            <td>
              <input className="limit-input" type="text" onChange={onLimitChange} maxLength="2" />
            </td>
          </tr>
        ]);
      default:
        return <span />;
    }
  }

  renderFormActions() {
    const { memberType } = this.props;

    switch (memberType) {
      case MemberTypes.EXISTING_MEMBERS:
        return (
          <button type="submit" className="test-member-form-submit">Search</button>
        );
      default:
        return <span />;
    }
  }

  renderMemberStatus() {
    const { members, memberType, memberStatus } = this.props;

    if (memberStatus === MemberStatuses.LOADING) {
      return <div className="test-member-status">Loading members ...</div>;
    } else if (memberStatus === MemberStatuses.LOAD_ERROR) {
      return (
        <div className="test-member-status error">
          There was an error loading members, please try again.
        </div>
      );
    } else if (members) {
      return (
        <div className="test-member-status">
          Loaded {members.length} test members
        </div>
      );
    } else if (memberType === MemberTypes.CSV_FILE) {
      return (
        <div className="test-member-instructions">
          Please use a spreadsheet saved to <strong>CSV format</strong> with <strong>no
          header row</strong> and the following columns:
          <ul>
            <li>A - Member's Health Plan ID</li>
            <li>B - First Name</li>
            <li>C - Last Name</li>
            <li>D - Date of Birth, in MM/DD/YYYY format</li>
            <li>E - Group ID (Required ONLY for UHC and WPS)</li>
            <li>F - Plan Code (Required ONLY for Highmark)</li>
            <li>G - Group Mover Flag (Situational - Performs group move for eligible candidates, when conditions are met)</li>
            <li>&nbsp;</li>
          </ul>
          <ul>
            <li>- Limit size of the member test file to &le; 250 members</li>
            <li>- NOTE: Files > 250 test members requires approval from the RTE team.</li>
            <li>- NOTE: the data for columns E, F and G are only situationally required and should only contain data when that data is required for the RTE submission for that RTE payer, or in the case of Group Mover Flag, you desire the Group Mover to occur for eligible candidates.</li>
            <li>&nbsp;</li>
            <li>
              Documentation and examples may be found
              <a href='https://teladoc.atlassian.net/wiki/spaces/EL/pages/89484538/RTE+Member+Testing+Tool' target="_blank"> here</a>
            </li>
          </ul>
        </div>
      );
    } else if (memberType === MemberTypes.EXISTING_MEMBERS) {
      return (
        <div className="test-member-instructions">
          Please fill out the above form as follows:
          <ul>
            <li>Admin Group ID (or multiple IDs, separated by comma)</li>
            <li>
              Payer - <strong>Only needed if Group ID is blank</strong>&nbsp;
              (Will test any members from the payer)
            </li>
            <li>Number of members to test (required)</li>
          </ul>
        </div>
      );
    } else {
      return <span />;
    }
  }

  render() {
    return (
      <div className="search test-member-chooser">
        <h4>Test Members</h4>
        <form onSubmit={this.handleSubmit}>
          <table className="fields">
            <tbody>
              {this.renderMemberTypeSelect()}
              {this.renderFormFields()}
            </tbody>
          </table>
          {this.renderFormActions()}
        </form>
        <br />
        {this.renderMemberStatus()}
      </div>
    );
  }
}

const mapStateToProps    = (state) => {
  const { memberType, members, memberStatus } = state.rteTest;
  return { memberType, members, memberStatus };
};

const mapDispatchToProps = { fetchMembers, setMemberType, setSelectedPayer };

export default connect(mapStateToProps, mapDispatchToProps)(TestMemberChooserUnconnected);
